//import $ from 'jquery';
import jumplist from '../components/jumplist';

export default {
    init() {
        jumplist(document.getElementById('categoryJumplist'));
    },
};
